import React from 'react';
import { SectionHeading } from './ui/SectionHeading';
import { COST_ROWS } from '../data/content';
export function CostOfInaction() {
  return <section className="bg-teal-50 py-14" data-id="element-49" data-mp="2pz0zmc8g1i0k">
      <div className="mx-auto max-w-page px-5" data-id="element-50" data-mp="2uy3rsw3brtr4">
        <SectionHeading eyebrow="La cuenta real" title="¿Cuánto te cuesta no tenerlo?" subtitle="El protocolo cuesta $27.990 una sola vez. Seguir igual también tiene precio, solo que lo pagás en cuotas." data-id="element-51" data-mp="2uw997ofj0dq7" />

        <div className="mt-8 overflow-hidden rounded-2xl border border-line bg-paper shadow-card" data-id="element-52" data-mp="34vrpnuw89hdi">
          <div className="grid grid-cols-2 gap-px bg-line" data-id="element-53" data-mp="38vsgkf0ijl1g">
            <div className="bg-night px-4 py-3 text-[11px] font-extrabold uppercase tracking-[0.12em] text-canvas/80" data-id="element-54" data-mp="3do21fgmrtuwv">
              Lo que pasa hoy
            </div>
            <div className="bg-flame px-4 py-3 text-[11px] font-extrabold uppercase tracking-[0.12em] text-white" data-id="element-55" data-mp="3nmhuhp5cze90">
              Lo que te cuesta
            </div>
          </div>
          <ul className="divide-y divide-line" data-id="element-56" data-mp="3sji0y164ej0n">
            {COST_ROWS.map(row => <li key={row.today} className="grid grid-cols-2 divide-x divide-line" data-id="element-57" data-mp="3eh98al0fha0m">
                <p className="px-4 py-4 text-[13px] leading-snug text-muted" data-id="element-58" data-mp="39gbs2dyzaq1r">{row.today}</p>
                <p className="px-4 py-4 text-[13px] font-bold leading-snug text-night" data-id="element-59" data-mp="34hifqovfh536">{row.cost}</p>
              </li>)}
          </ul>
        </div>

        <p className="mt-6 text-center font-display text-[19px] font-bold italic leading-snug text-teal-700 sm:text-[22px]" data-id="element-60" data-mp="30irr76512vro">
          Cambiar cuesta $27.990. Quedarte igual te cuesta otro año.
        </p>
      </div>
    </section>;
}